import { useCallback, useState } from 'react'
import { Beer, TrendingUp, Receipt } from 'lucide-react'
import AdminScreenShell, { Tegel, StatusRij } from '@/components/AdminScreenShell'
import { adminAPI } from '@/lib/api'

const eur = (c) => `€${(Number(c || 0) / 100).toFixed(2)}`

export default function AdminBarScreen() {
  const [d, setD] = useState(null)
  const load = useCallback(async () => {
    const r = await adminAPI.schermBar(); setD(r.data)
  }, [])
  const open = d?.openAccounts ?? { aantal:0, totaal_cents:0 }
  const top  = d?.topSpenders ?? []
  const alltime = d?.alltime ?? []
  const gem = open.aantal ? Math.round(open.totaal_cents / open.aantal) : 0

  return (
    <AdminScreenShell title="Bar" subtitle="Openstaande rekeningen · top-spenders"
                      icon={Beer} refreshMs={20_000} onRefresh={load}>
      <div className="grid grid-cols-4 gap-3 mb-4">
        <Tegel label="Open rekeningen" waarde={open.aantal}
               kleur={open.aantal > 30 ? '#FFB57A' : '#B4FF39'} groot />
        <Tegel label="Totaal openstaand" waarde={eur(open.totaal_cents)}
               kleur="#61E294" />
        <Tegel label="Gemiddelde"       waarde={eur(gem)}
               sub="per open rekening" kleur="#B4FF39" />
        <Tegel label="Grootste"
               waarde={top[0]?.username ?? '—'}
               sub={eur(top[0]?.totaal_cents)} kleur="#B4FF39" />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="rounded-[6px] border border-border bg-card p-4">
          <h2 className="font-mono text-[11px] uppercase tracking-[0.3em] text-muted-foreground mb-3">
            <TrendingUp className="h-3 w-3 inline mr-1" /> Grootste openstaande rekeningen
          </h2>
          {top.length === 0 ? (
            <div className="text-muted-foreground text-sm">Geen open rekeningen.</div>
          ) : top.map((t, i) => (
            <StatusRij key={i+t.username} naam={`${i+1}. ${t.username}`}
                       sub={t.bestellingen ? `${t.bestellingen} bestellingen` : ''}
                       status={eur(t.totaal_cents)} kleur="#B4FF39" />
          ))}
        </div>

        <div className="rounded-[6px] border border-border bg-card p-4">
          <h2 className="font-mono text-[11px] uppercase tracking-[0.3em] text-muted-foreground mb-3">
            <Receipt className="h-3 w-3 inline mr-1" /> Leaderboard (all-time)
          </h2>
          {alltime.length === 0 ? (
            <div className="text-muted-foreground text-sm">Geen leaderboard-data.</div>
          ) : alltime.map((b, i) => (
            <StatusRij key={i}
              naam={`${i+1}. ${b.username ?? b.name ?? '—'}`}
              sub={b.orders_count ? `${b.orders_count} bestellingen` : ''}
              status={eur(b.total_cents ?? 0)} kleur="#B4FF39" />
          ))}
        </div>
      </div>
    </AdminScreenShell>
  )
}
